import React from "react"
import { Button, Box, Grid, Typography, MenuItem } from "@mui/material"
import { ButtonWithOptions } from "components/common/ButtonWithOptions"

const BUTTONS: ('primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success')[]
 = [
    "primary",
    "secondary",
    "error",
    "warning",
    "info",
    "success",
]

type ButtonShowcaseProps = {
    size: "small" | "medium"
}

const ButtonShowcase: React.FC<ButtonShowcaseProps> = ({size}) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Typography className="text-xl font-bold">Buttons Showcase</Typography>
      <Box>
        {BUTTONS.map((color) => (
          <Grid key={color} container gap={6} padding={1} columns={3}>
            <Grid>
                <Button color={color} size={size} variant="contained">
                    Contained
                </Button>
            </Grid>
            <Grid>
                <Button color={color} size={size} variant="outlined">
                    Outlined
                </Button>
            </Grid>
            <Grid>
                <Button color={color} size={size} variant="text">
                    Text
                </Button>
            </Grid>
          </Grid>
        ))}
      </Box>
      <Typography className="text-xl font-bold">Buttons With Options</Typography>
      <Box>
        {BUTTONS.map((color) => (<Grid key={color} container gap={6} padding={1} columns={3}>
          <Grid>
            <ButtonWithOptions
              key={color}
              color={color}
              size={size}
              variant="contained"
              menu={<>
                <MenuItem onClick={() => console.log("Option 1")}>Option 1</MenuItem>
                <MenuItem onClick={() => console.log("Option 2")}>Option 2</MenuItem>
              </>}
            >
              Button with Options
            </ButtonWithOptions>
          </Grid>
          <Grid>
            <ButtonWithOptions
              key={color}
              color={color}
              size={size}
              variant="outlined"
              menu={<>
                <MenuItem onClick={() => console.log("Option 1")}>Option 1</MenuItem>
                <MenuItem onClick={() => console.log("Option 2")}>Option 2</MenuItem>
              </>}
            >
              Button with Options
            </ButtonWithOptions>
          </Grid>

          <Grid>
            <ButtonWithOptions
              key={color}
              color={color}
              size={size}
              variant="text"
              menu={<>
                <MenuItem onClick={() => console.log("Option 1")}>Option 1</MenuItem>
                <MenuItem onClick={() => console.log("Option 2")}>Option 2</MenuItem>
              </>}
            >
              Button with Options
            </ButtonWithOptions>
          </Grid>
        </Grid>))}
      </Box>
    </Box>
  )
}

export default ButtonShowcase
